"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogContent: function() {
        return _index.DialogContent;
    },
    dialogContentClassNames: function() {
        return _index.dialogContentClassNames;
    },
    renderDialogContent_unstable: function() {
        return _index.renderDialogContent_unstable;
    },
    useDialogContentStyles_unstable: function() {
        return _index.useDialogContentStyles_unstable;
    },
    useDialogContent_unstable: function() {
        return _index.useDialogContent_unstable;
    }
});
const _index = require("./components/DialogContent/index");
